<template>
  <div>
    <Modal
      :fullscreen="fullscreen"
      :title="scale==1?'图片预览':('图片预览【'+scale+'倍】')"
      @on-cancel="closeP"
      class="noPaddingModal"
      footer-hide
      v-model="showPreview"
      width="90vw"
    >
      <div class="toolBarContainer">
        <div class="toolBars">
          <Tooltip content="顺时针旋转90度">
            <span @click="minuAngle" class="transL toolIcon"></span>
          </Tooltip>
          <Tooltip content="顺时针旋转90度">
            <span @click="plusAngle" class="transR toolIcon"></span>
          </Tooltip>

          <Tooltip content="放大">
            <span :class="'add toolIcon '+ (scale==2?'disable':'') " @click="enlarge"></span>
          </Tooltip>
          <Tooltip content="缩小">
            <span :class="'minu toolIcon '+ (scale==0.6?'disable':'') " @click="reduce"></span>
          </Tooltip>
        </div>
      </div>
      <div style="position: relative; width: 100%; height:68vh; text-align: center; overflow:auto">
        <div class="previweImgContainer">
          <img :src="imageData" :style="{width: 'auto'}" />
          <canvas id="mockImg" style="width: 100%; height: 100%; display: none" />
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    fileUrl: {
      required: true
    },
    show: {
      required: false,
      default: false
    },
    fullscreen: {
      required: false,
      default: false
    }
  },
  computed: {
    showText: function () {
      let user = this.$store.getters['userInfo/user'] || {}
      console.log('this.$store.state.user', user)
      // let name = user.account || user.name
      return user.name + "【" + user.account + "】"
    },
    subText: function () {
      return this.$moment().format("YYYY-MM-DD HH:mm:ss")
    }
  },
  watch: {
    show: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.$nextTick(() => {
            this.createdImg()
          })
        }
        this.showPreview = val
      }
    }
  },
  data () {
    return {
      angle: 0,
      showPreview: false,
      maxWidth: '100%',
      maxHeight: '100%',
      scale: 1,
      transformOrigin: '0 0',
      marginTop: '',
      marginLeft: '',
      imageData: ''
    }
  },
  methods: {
    createdImg () {
      let windowW = window.innerWidth * 0.9
      let windowH = window.innerHeight * 0.68 - 10
      console.log('windowW =', windowW)
      console.log('windowH =', windowH)
      // 获取到图片后使用canvas获取旋转90度后的图片
      const imgN = new Image()
      imgN.src = this.fileUrl + '?' + new Date().getTime()
      imgN.setAttribute('crossOrigin', '')
      const canvas = document.getElementById('mockImg')
      canvas.style.background = 'transparent'
      const context = canvas.getContext('2d')
      // context.fillStyle = 'white'
      // context.fillRect(0, 0, canvas.width, canvas.height)
      console.log('canvas size=')
      console.log(canvas.width, canvas.height)
      imgN.onload = () => {
        let orgW = imgN.width
        let orgH = imgN.height
        let rateW = windowW / orgW
        let rateH = windowH / orgH
        let rate = 1
        if (rateH < 1 || rateW < 1) {
          rate = rateW > rateH ? rateH : rateW
        }
        console.log('createdImg', rate)
        // 等比例缩小
        const imgW = orgW * rate * this.scale
        const imgH = orgH * rate * this.scale
        if (this.scale != 1) {
          context.scale(this.scale, this.scale)
        }
        let count = this.angle % 360
        switch (count) {
          case 0: // 旋转360°
            canvas.width = imgW
            canvas.height = imgH
            context.drawImage(imgN, 0, 0, imgW, imgH)
            break
          case -270:
          case 90: // 旋转90°
            canvas.width = imgH
            canvas.height = imgW
            context.rotate(Math.PI / 2)
            context.drawImage(imgN, 0, -imgH, imgW, imgH)
            break
          case -180:
          case 180: // 旋转180°
            canvas.width = imgW
            canvas.height = imgH
            context.rotate(Math.PI)
            context.drawImage(imgN, -imgW, -imgH, imgW, imgH)
            break
          case -90:
          case 270: // 旋转270°
            canvas.width = imgH
            canvas.height = imgW
            context.rotate(3 * Math.PI / 2)
            context.drawImage(imgN, -imgW, 0, imgW, imgH)
            break

        }
        // 添加水印
        this.mask(canvas, context)
        this.imageData = canvas.toDataURL('image/png')
      }
    },
    mask: function (canvas, ctx) {
      let fullWidth = canvas.width
      let fullHeight = canvas.height
      let width1 = ctx.measureText(this.showText).width
      let width2 = ctx.measureText(this.subText).width
      let width = (width1 > width2 ? width1 : width2) * 2
      let height = 36 * 4

      let cols = fullWidth / width
      let rows = fullHeight / height
      console.log('mask data =')
      console.log(cols, rows)
      for (let row = 0; row < rows; row++) {

        for (let col = 0; col < cols; col++) {
          if ((col % 2 == 0 && row % 2 == 1) || (col % 2 == 1 && row % 2 == 0)) continue
          // 设置字体
          ctx.font = "14px 微软雅黑 "
          // 设置字体颜色
          ctx.fillStyle = "#c1c1c1"
          ctx.textAlign = "center"
          ctx.textBaseline = 'middle'
          // 添加文字和位置
          ctx.translate(width / 3 + (col * width), 20 + (row * height))

          ctx.rotate(-30 * Math.PI / 180)
          ctx.fillText(this.showText, 0, height / 3)

          ctx.font = "12px 微软雅黑 "
          ctx.fillStyle = "#ccc"
          ctx.fillText(this.subText, 0, height / 2)
          ctx.setTransform(1, 0, 0, 1, 0, 0)
        }
      }
    },
    closeP: function () {
      this.previewUrl = ''
      this.showPreview = false
      this.$emit('close')
    },
    minuAngle: function () {
      this.angle -= 90
      this.createdImg()
    },
    plusAngle: function () {
      this.angle += 90
      this.createdImg()
    },
    enlarge: function () {
      if (this.scale < 3) {
        this.scale = Number.parseFloat((this.scale + 0.2).toFixed(1))
        this.createdImg()
      }
    },
    reduce: function () {
      if (this.scale > 0.4) {
        this.scale = Number.parseFloat((this.scale - 0.2).toFixed(1))
        this.createdImg()
      }
    },
  }
}
</script>
<style lang="less" scoped>
.toolBarContainer {
  padding: 5px 10px;
  display: flex;
  justify-content: flex-end;
}
.toolBars {
  display: flex;
  width: max-content;

  .transL {
    background-image: url(@/assets/static/images/im/transL.png);
  }

  .transR {
    background-image: url(@/assets/static/images/im/transR.png);
  }

  .add {
    background-image: url(@/assets/static/images/im/add.png);
  }

  .minu {
    background-image: url(@/assets/static/images/im/minu.png);
  }

  .toolIcon {
    width: 1.4rem;
    height: 1.4rem;
    font-size: 1.6rem;
    display: block;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 2px 3px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .toolIcon.disable {
    cursor: not-allowed;
    color: #eee;
  }
}

.previweImgContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>